import PlaceholderImage from "./fallback.jpg?no-inline";

interface ImageProps {
  src?: string;
  alt?: string;
  className?: string;
}

const Image = ({ src = PlaceholderImage, alt, className }: ImageProps) => {
  return (
    <img
      src={src || PlaceholderImage}
      alt={alt}
      className={className}
      loading="lazy"
    />
  );
};

export default Image;
